export default "__VITE_ASSET__DYZDVPLC__"